import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UserService } from './user.service';
import { Service } from '../models/service';
import { Observable, of } from 'rxjs';
import { NotificationModel } from '../models/notification';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  versions = null;
  constructor(private api: ApiService, private userService: UserService) { }

  deleteOffer(id: any): any {
    return this.api.delete('/admin/offers-and-promos/' + id);
  }
  updateOffer(id: any, data: any): any {
    return this.api.post('/admin/offers-and-promos/' + id, data);
  }
  deleteAgencyMap(id: any): any {
    return this.api.delete('/admin/agencies/' + id);
  }
  updateAgencyMap(id: any, data: any): any {
    return this.api.post('/admin/agencies/' + id, data);
  }
  agencies() {
    return this.api.get('/admin/agencies');
  }
  offersAndPromos(type = '', exact = false) {
    return this.api.get('/admin/offers-and-promos?type=' + type + '&exact=' + exact);
  }
  pushNotification(data: {
    title: string,
    content: string,
    topic: string
  }) {
    return this.api.post('/admin/push-notifications', data);
  }
  notifications(state?: string) {
    return this.api.get('/admin/push-notifications' + (state ? '?state=' + state : ''));
  }
  createAgence(map: {
    position: string;
    name: string;
    description: string;
  }) {
    return this.api.post('/admin/agencies', map);
  }
  createOfferAndPromo(data: {
    type: string;
    title;
    description: string;
    data?: string;
    startDate?: any;
    endDate?: any;
    action: string;
  }) {
    return this.api.post('/admin/offers-and-promos', data);
  }
  createPushSms(data) {
    console.log('>>>>>=' + JSON.stringify(data.restrictedUserFile));
    return this.api.post('/admin/push-sms', data);
  }
  services(parentId: any): any {
    return this.api.get('/admin/services' + (parentId ? '?parent=' + parentId : ''));
  }
  service(id: any): any {
    return this.api.get('/admin/services/' + id);
  }
  createService(data: Service) {
    return this.api.post('/admin/services', data);
  }
  editService(id: any, data: Service) {
    return this.api.post('/admin/services/' + id, data);

  }
  deleteService(id: any): any {
    return this.api.delete('/admin/services/' + id);
  }

  createAd(data) {
    return this.api.post('/admin/ads', data);
  }

  editAd(id, data) {
    return this.api.post('/admin/ads/' + id, data);
  }
  deleteAd(id: any): any {
    return this.api.delete('/admin/ads/' + id);
  }
  ads(): any {
    return this.api.get('/admin/allAds');
  }
  getCounters(): Observable<any> {
    return this.api.get('/admin/counters/all');
  }
  saveCounter(counter): Observable<any> {
    return this.api.post('/admin/counters/save', counter);
  }
  deleteCounter(id): Observable<any> {
    return this.api.delete('/admin/counters/' + id);
  }
  settings(source) {
    return this.api.get('/admin/settings', {
      source
    });
  }
  saveSetting(id, setting, source?) {
    return this.api.post('/admin/settings/' + id + (source ? '?source=' + source : ''), setting);
  }

  // profil
  profils() {
    return this.api.get('/admin/profils');
  }
  newProfil(data) {
    return this.api.post('/admin/profils', data);
  }
  updateProfil(id, data) {
    return this.api.post('/admin/profils/' + id, data);
  }

  profil(id) {
    return this.api.get('/admin/profils/' + id);
  }

  profilActions() {
    return this.api.get('/admin/actions');
  }

  disableProfil(id) {
    return this.api.delete('/admin/profils/' + id);
  }

  // users
  newUser(data) {
    return this.api.post('/admin/users', data);
  }
  updateUser(id, data) {
    return this.api.post('/admin/users/' + id, data);
  }
  updateUserPassword(id, data) {
    return this.api.put('/admin/users/' + id + '/change-password', data);
  }
  user(id) {
    return this.api.get('/admin/users/' + id);
  }
  users() {
    return this.api.get('/admin/users');
  }
  deleteUser(id) {
    return this.api.delete('/admin/users/' + id);
  }
  enableUser(id) {
    return this.api.post('/admin/users/enable/' + id, {});
  }
  saveFaqQuestion(data: any): any {
    return this.api.post('/admin/faqQuestion/save', data);
  }

  editFaqQuestion(id, data: any): any {
    return this.api.post('/admin/faqQuestion/questions/' + id, data);
  }
  deleteFaq(id): any {
    return this.api.delete('/admin/faqQuestion/questions/' + id);
  }

  faqQuestions(parent?) {
    return this.api.get('/admin/faqs' + (parent ? '?parent=' + parent : ''));
  }

  faqQuestion(id: any): any {
    return this.api.get('/admin/faqQuestion/question/' + id);
  }

  // configs(key: string) {
  //   return this.api.get('/admin/internalConfigs', {
  //     key
  //   });
  // }
  appServicesPromos() {
    return this.api.get('/admin/internalConfigs', {
      key: 'APP_SERVICES_PROMO_CONFIG'
    });
  }


  blockedUsers(data?: {
    limit: number,
    offset: number
  }) {
    return this.api.get('/admin/access/users/blocked', data);
  }
  unblock(data: {
    msisdn: string,
    reason?: string,
    access: string,
    agent?: string,
  }) {
    return this.api.post('/admin/access/users/unblock', data);
  }
  block(data: {
    msisdn: string,
    reason?: string,
    access: string,
    agent?: string,
  }) {
    return this.api.post('/admin/access/users/block', data);
  }


  statsBestUsers(data: {
    from: any,
    to: any
  }) {
    return this.api.post('/admin/stats/bestUsers', data);
  }
  userFullUsage(data: {
    from: any,
    to: any,
    msisdn: string;
  }) {
    return this.api.post('/admin/stats/userFullUsage', data);
  }
  userUsage(data: {
    from: any,
    to: any,
    msisdn: string;
  }) {
    console.log(this);
    return this.api.post('/admin/stats/userUsage', data);
  }
  transactionUsages(data: {
    from: any,
    to: any,
    service: string;
  }) {
    return this.api.post('/admin/stats/transactionUsage', data);
  }
  statsOsUsage() {
    return this.api.get('/admin/stats/osInstall');
  }
  statsServiceUsage(data: {
    from: any,
    to: any
  }) {
    return this.api.post('/admin/stats/serviceUsage', data);
  }
  statsTransactions(data: {
    from: any,
    to: any,
    service?: string
  }) {
    return this.api.post('/admin/stats/transactions', data);
  }
  usersStats(page: number, size: number, filter: any) {
    return this.api.post('/admin/stats/users?page=' + page + '&size=' + size, filter);
  }
  activeUsersStats(page: number, size: number, filter: any) {
    return this.api.post('/admin/stats/active-users?page=' + page + '&size=' + size, filter);
  }
  terminals() {
    return this.api.get('/admin/stats/terminals');
  }
  appVersions() {
    if (this.versions) {
      return of(this.versions);
    }
    const seq = this.api.get('/admin/stats/versions');
    seq.subscribe((p: any) => this.versions = p);
    return seq;
  }
  usersStatsCount(filter: any) {
    return this.api.post('/admin/stats/users/count', filter);
  }
  activeUsersStatsCount(filter: any) {
    return this.api.post('/admin/stats/active-users/count', filter);
  }

  /**
   * find faqs list
   */
  tarifs(code?: any) {
    return this.api.get('/admin/tarifs', {
      code
    });
  }
  createTarif(tarif) {
    return this.api.post('/admin/tarifs', tarif);
  }
  editTarif(id, tarif) {
    return this.api.post('/admin/tarifs/' + id, tarif);
  }
  deleteTarif(id) {
    return this.api.delete('/admin/tarifs/' + id);
  }

  async export(filter: any) {
    console.log('Downloading: ' + filter);
    try {
      const data = await this.api.post('/admin/stats/users/exports', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'yame_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }
  async exportActiveUsers(filter: any) {
    console.log('Downloading: ' + filter);
    try {
      const data = await this.api.post('/admin/stats/active-users/exports', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'yame_active_users_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }
  async exportBestUsages(filter: any) {
    console.log('Downloading: ' + filter);
    try {
      const data = await this.api.post('/admin/stats/export/bestUsers', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'oms_best_user_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }
  async exportStats(filter: any) {
    console.log('Downloading: ' + filter);
    try {
      const data = await this.api.post('/admin/stats/export/s', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'yame_services_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }

  async exportStatsServiceUsage(filter: any) {
    console.log('Downloading: statsServiceUsage');
    try {
      const data = await this.api.post('/admin/stats/export/serviceUsage', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'oms_services_usage_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }
  async exportTransactions(filter: any) {
    console.log('Downloading: transactions');
    try {
      const data = await this.api.post('/admin/stats/export/transactions', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'yame_transactions_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }
  async exportTransactionsUsers(filter: any) {
    console.log('Downloading: transactions');
    try {
      const data = await this.api.post('/admin/stats/export/transactions/users', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'yame_transactions_users_export_' + new Date().getTime() + '.csv';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }

  referrers(page: number, size: number, filter: any) {
    return this.api.post('/admin/sponsorships/referrers?page=' + page + '&size=' + size, filter);
  }
  referrals(filter: {
    referrer: string;
    page: string;
    size: string;
  }) {
    return this.api.get('/admin/sponsorships/referrals', filter);
  }

  async referrersExport(page: number, size: number, filter: any) {
    const date = new Date();
    try {
      const data = await this.api.post('/admin/sponsorships/referrers/export?page=' + page + '&size=' + size, filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'export_referrers_' + (date.getFullYear() + '-' + (date.getMonth() + 1) + (date.getDay())) + '.xlsx';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }

  models(data: {
    page: number,
    size: number
  }): Observable<any> {
    return this.api.get('/admin/notifications/models', data);
  }
  modelByName(name: string): Observable<any> {
    return this.api.get('/admin/notifications/model/' + name + '/byName');
  }
  model(id: number): Observable<any> {
    return this.api.get('/admin/notifications/model/' + id);
  }

  newModel(data: NotificationModel): Observable<any> {
    return this.api.post('/admin/notifications/models', data);
  }
  editModel(id: number, data: NotificationModel): Observable<any> {
    return this.api.put('/admin/notifications/models/' + id, data);
  }

  deleteModel(id: number): Observable<any> {
    return this.api.delete('/admin/notifications/models/' + id);
  }

  jackPotsData(): Observable<any> {
    return this.api.get('/admin/jackpots/data');
  }
  newJackPotData(data: any): Observable<any> {
    return this.api.post('/admin/jackpots/data', data);
  }
  editJackPotData(id: number, data: any): Observable<any> {
    return this.api.put('/admin/jackpots/data/' + id, data);
  }
  deleteJackPotData(id: number): Observable<any> {
    return this.api.delete('/admin/jackpots/data/' + id);
  }

  jackPotAccesses(data: {
    msisdn: string;
    page: number,
    size: number,
    to?: string,
    from?: string,
    order?: string
  }): Observable<any> {
    return this.api.post('/admin/jackpots/accesses', data);
  }
  jackPotGifts(data: {
    msisdn: string;
    page: number,
    size: number,
    to?: string,
    from?: string,
    order?: string
  }): Observable<any> {
    return this.api.post('/admin/jackpots/gifts', data);
  }

  async jackPotAccessesExport(filter: {
    msisdn: string;
    page: number,
    size: number,
    to?: string,
    from?: string,
    order?: string
  }) {
    const date = new Date();
    try {
      const data = await this.api.post('/admin/jackpots/accesses/export', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'export_jackpot_accesses_' + (date.getFullYear() + '-' + (date.getMonth() + 1) + (date.getDay())) + '.xlsx';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }
  async jackPotGiftsExport(filter: {
    msisdn: string;
    page: number,
    size: number,
    to?: string,
    from?: string,
    order?: string
  }) {
    const date = new Date();
    try {
      const data = await this.api.post('/admin/jackpots/gifts/export', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'export_jackpot_gifts_' + (date.getFullYear() + '-' + (date.getMonth() + 1) + (date.getDay())) + '.xlsx';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }

  kycTicket(): Observable<any> {
    return this.api.get('/admin/kyc/ticket');
  }
  kycTickets(): Observable<any> {
    return this.api.get('/admin/kyc/tickets');
  }
  kycValidate(ticket: number, data: any): Observable<any> {
    return this.api.post('/admin/kyc/' + ticket + '/validate', data);
  }


  kycImportAgents(data: any): Observable<any> {
    return this.api.post('/admin/kyc/agents/import', data);
  }
  kycCreateAgent(data: any): Observable<any> {
    return this.api.post('/admin/kyc/agents/create', data);
  }
  kycEditAgent(data: any): Observable<any> {
    return this.api.post('/admin/kyc/agents/edit', data);
  }
  kycDeleteAgent(data: {id: string, login?: string}): Observable<any> {
    return this.api.post('/admin/kyc/agents/delete', data);
  }
  kycAgentPing(): Observable<any> {
    return this.api.post('/admin/kyc/agent/ping', {});
  }
  kycAgents({page, size}): Observable<any> {
    return this.api.get('/admin/kyc/agents', {
      page: page + '',
      size: size + ''
    });
  }
  kycAgentSearch({field, term, page, size}): Observable<any> {
    return this.api.get('/admin/kyc/agents/search', {
      page: page + '',
      size: size + '',
      field,
      term,
    });
  }
  kycActions(): Observable<any> {
    return this.api.get('/admin/kyc/actions');
  }

  createStory(data) {
    return this.api.post('/admin/stories', data);
  }

  editStory(id, data) {
    return this.api.post('/admin/stories/' + id, data);
  }
  deleteStory(id: any): any {
    return this.api.delete('/admin/stories/' + id);
  }
  story(id?): any {
    return this.api.get('/admin/stories/' + id);
  }
  stories(): any {
    return this.api.get('/admin/stories');
  }

  //======stories lite======//
  
  createStoryLite(data) {
    return this.api.post('/admin/stories-add-lite', data);
  }
  editStoryLite(id, data) {
    return this.api.post('/admin/stories-update-lite/' + id, data);
  }
  deleteStoryLite(id: any): any {
    return this.api.delete('/admin/stories-lite/' + id);
  }
  storyLite(id?): any {
    return this.api.get('/admin/stories-lite/' + id);
  }
  storiesLite(): any {
    return this.api.get('/admin/stories-lite');
  }
  //======stories lite======//

  //======stories wido======//
  
  createStoryWido(data) {
    return this.api.post('/admin/stories-add-wido', data);
  }
  editStoryWido(id, data) {
    return this.api.post('/admin/stories-update-wido/' + id, data);
  }
  deleteStoryWido(id: any): any {
    return this.api.delete('/admin/stories-wido/' + id);
  }
  storyWido(id?): any {
    return this.api.get('/admin/stories-wido/' + id);
  }
  storiesWido(): any {
    return this.api.get('/admin/stories-wido');
  }
  //======stories wido======//


  //======stories corner offers======//
  
  createCornerOffers(data) {
    return this.api.post('/admin/corner-add-offers', data);
  }
  editCornerOffers(data) {
    return this.api.post('/admin/corner-update-offers', data);
  }
  deleteCornerOffers(id: any): any {
    return this.api.delete('/admin/corner-delete-offers/' + id);
  }
  cornerOffersById(id?): any {
    return this.api.get('/admin/stories-wido/' + id);
  }
  cornerOffers(): any {
    return this.api.get('/admin/corner-offers');
  }
  //======stories corner offers======//

  //======kdo config======//
  getAnimations(): any {
    return this.api.get('/admin/kdo-list-animation');
  }
  getGain(): any {
    return this.api.get('/admin/kdo-list-gain');
  }
  createAnimation(data): any {
    return this.api.post('/admin/kdo-add-animation',data);
  }
  updateAnimation(data): any {
    return this.api.post('/admin/kdo-update-animation',data);
  }
  createGain(data,animationIds): any {
    return this.api.post('/admin/kdo-add-gain?animationIds='+animationIds,data);
  }
  updateGain(data,animationIds): any {
    return this.api.post('/admin/kdo-update-gain?animationIds='+animationIds,data);
  }
  updateGainOnly(data): any {
    return this.api.post('/admin/kdo-update-gain-only',data);
  }
  //======kdo config======//



  //====== corner tv======//
  
  createCornerTV(data, mediaIds,sectionIds) {
    return this.api.post('/admin/corners-tv-add?mediaIds='+mediaIds +'&sectionIds='+sectionIds, data);
  }
  editCornerTV(data, mediaIds,sectionIds) {
    return this.api.post('/admin/corners-tv-update?mediaIds='+mediaIds +'&sectionIds='+sectionIds, data);
  }
  // editCornerTV(id, data) {
  //   return this.api.post('/admin/corners-tv-update/' + id, data);
  // }
  assignSectionToCornerTV(id, data, sectionIds) {
    return this.api.post('/admin/corners-tv-update/' + id + '?sectionIds=' + sectionIds, data);
  }
  assignMediaToCornerTV(id, data, mediaIds) {
    return this.api.post('/admin/corners-tv-update/' + id + '?mediaIds=' + mediaIds, data);
  }
  assignTargetToCornerTV(id, data, targetId) {
    return this.api.post('/admin/corners-tv-update/' + id + '?targetId=' + targetId, data);
  }
  deleteCornerTV(id: any): any {
    return this.api.delete('/admin/corners-tv-delete/' + id);
  }
  cornerTVById(id?): any {
    return this.api.get('/admin/corners-tv/' + id);
  }
  cornersTV(): any {
    return this.api.get('/admin/corners-tv');
  }
  //======stories corner offers======//



  //======stories corner section======//
  
  createCornerSection(data, offerIds) {
    return this.api.post('/admin/corner-add-section?offerIds='+offerIds, data);
  }
  editCornerSection(data, offerIds) {
    return this.api.post('/admin/corner-update-section?offerIds='+offerIds, data);
  }
  assignOfferToCornerSection(sectionId, offerIds) {
    return this.api.get('/admin/corner-assign-offers-section?sectionId='+sectionId+'&offerIds='+offerIds);
  }
  
  deleteCornerSection(id: any): any {
    return this.api.delete('/admin/corner-delete-section/' + id);
  }
  cornerSectionById(id?): any {
    return this.api.get('/admin/stories-wido/' + id);
  }
  cornersSection(): any {
    return this.api.get('/admin/corner-section');
  }
  //======stories corner section======//



  //====== corner target-customer======//
  
  createTargetCustomer(data) {
    return this.api.post('/admin/corner-add-target-customer', data);
  }
  editTargetCustomer(id, data) {
    return this.api.post('/admin/corner-update-target-customer/' + id, data);
  }
  deleteTargetCustomer(id: any): any {
    return this.api.delete('/admin/corner-delete-target-customer/' + id);
  }
  targetCustomerById(id?): any {
    return this.api.get('/admin/target-customer/' + id);
  }
  targetCustomer(): any {
    return this.api.get('/admin/corner-target-customer');
  }
  //====== corner target-customer======//

  //====== corner formule======//
  
  createFormuleAndCustomer(data) {
    return this.api.post('/admin/add-formule-customer', data);
  }
  createFormule(data) {
    return this.api.post('/admin/corner-add-formule', data);
  }
  editFormule(id, data) {
    return this.api.post('/admin/corner-update-formule/' + id, data);
  }
  deleteFormule(id: any): any {
    return this.api.delete('/admin/corner-delete-formule/' + id);
  }
  FormuleById(id?): any {
    return this.api.get('/admin/formule/' + id);
  }
  getFormule(): any {
    return this.api.get('/admin/corner-list-formule');
  }
  //====== corner formule======//

  //====== corner formule======//
  
  createCustomer(data) {
    return this.api.post('/admin/corner-add-customer', data);
  }
  editCustomer(id, data) {
    return this.api.post('/admin/corner-update-customer/' + id, data);
  }
  deleteCustomer(id: any): any {
    return this.api.delete('/admin/corner-delete-customer/' + id);
  }
  customerById(id?): any {
    return this.api.get('/admin/customer/' + id);
  }
  getCustomer(): any {
    return this.api.get('/admin/corner-list-customer');
  }
  //====== corner formule======//



  //======stories corner media======//
  
  createCornerMedia(data) {
    return this.api.post('/admin/corner-add-media', data);
  }
  editCornerMedia(data) {
    return this.api.post('/admin/corner-update-media', data);
  }
  deleteCornerMedia(id: any): any {
    return this.api.delete('/admin/corner-delete-media/' + id);
  }
  cornerMediaById(id?): any {
    return this.api.get('/admin/stories-wido/' + id);
  }
  cornersMedia(): any {
    return this.api.get('/admin/corner-media');
  }
  //======stories corner media======//

  /**
   * Sponsorship services
   */

  findSponsorshipConfig() {
    return this.api.get('/admin/sponsorships/config');
  }

  getSponsorshipOctroiBonus(criteria: any) {
    return this.api.post(`/admin/sponsorships/octroi-bonus`, criteria);
  }

  async exportSponsorshipOctroiBonus(filter: any) {
    console.log('Downloading: ' + filter);
    try {
      const data = await this.api.post('/admin/sponsorships/octroi-bonus/export', filter, {
        responseType: 'blob'
      }).toPromise();
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'sponsoring_bonus_export_' + new Date().getTime() + '.xlsx';
      link.click();
      return data;
    } catch (error) {
      return null;
    }
  }

  customers(pageNumber: number, pageSize: number, keyWord: string) {
    return this.api.get(`/admin/app-users?page=${pageNumber}&size=${pageSize}${keyWord ? '&keyWord=' + keyWord : ''}`);
  }
  rattachement(pageNumber: number, pageSize: number, keyWord: string) {
    return this.api.get(`/admin/attach-histo?page=${pageNumber}&size=${pageSize}${keyWord ? '&keyWord=' + keyWord : ''}`);
  }

  getDalalTones() {
    return this.api.get(`/admin/dalal-tones`);
  }

  saveTone(data, id): Observable<any> {
    return this.api.post(`/admin/dalal-tones/save${!!id ? '?id=' + id : ''}`, data);
  }

  mobileAppServices() {
    return this.api.get(`/admin/app-services`);
  }

  saveMobileAppServices(data: any): Observable<any> {
    return this.api.post(`/admin/app-services`, data);
  }
  homeProfit() {
    return this.api.get(`/admin/home-profit`);
  }

  saveHomeProfit(data: any): Observable<any> {
    return this.api.post(`/admin/home-profit`, data);
  }

  jackpotConfigs(): Observable<any> {
    return this.api.get('/admin/jackpots/configs');
  }
  storiesConfigs(): Observable<any> {
    return this.api.get('/admin/stories/configs');
  }
  appDeepLinks(): Observable<any> {
    return this.api.get('/admin/app-deep-links');
  }
  profiles(): Observable<any> {
    return this.api.get('/admin/app-profiles');
  }
  dalalTypes(): Observable<any> {
    return this.api.get('/admin/dalal-tones/types');
  }
  actionConfigs(): Observable<any> {
    return this.api.get('/admin/actions-configs');
  }
  offerTypes(): Observable<any> {
    return this.api.get('/admin/ags');
  }
}
